<header class="baer-header">
  <h1 id="support" class="site-page-title"><span class="large-font">Support</span></h1>
</header>
<main id="main-content" class="main-content">
  <section class="padding-y-2 padding-x-1">
    <div class="grid-container padding-x-1">
      <h2 class="usa-heading font-sans-lg margin-top-2 margin-bottom-2">User Guides</h2>
      <div class="usa-divider width-full margin-y-2"></div>
      <ul class="usa-list usa-list--unstyled">
        @for (pair of guidePairs; track pair.right) {
          <li class="margin-0">
            <div class="grid-row grid-gap-lg flex-align-start">
              <div class="grid-col-12 desktop:grid-col-6">
                <div class="guide-cell border-bottom-1px border-base-lighter padding-y-2">
                  <div class="grid-row grid-gap-2 flex-align-center">
                    <div class="grid-col-auto">
                      <fa-icon [icon]="faFileWord"
                               class="text-blue-50 fa-lg file-badge display-inline-block text-middle"></fa-icon>
                    </div>
                    <div class="grid-col fill">
                      <div class="file-title text-bold">{{ pair.left.title }}</div>
                    </div>
                    <div class="grid-col-auto">
                      <a class="usa-link display-inline-flex flex-align-center"
                         [href]="pair.left.href" target="_blank" rel="noopener"
                         aria-label="Open {{ pair.left.title }} (opens in a new tab)">
                        <fa-icon [icon]="faArrowUpRightFromSquare"
                                 class="fa-regular fa-green" aria-label="close"></fa-icon>
                        &nbsp;Open
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid-col-12 desktop:grid-col-6">
                @if (pair.right) {
                  <div class="guide-cell border-bottom-1px border-base-lighter padding-y-2">
                    <div class="grid-row grid-gap-2 flex-align-center">
                      <div class="grid-col-auto">
                        <fa-icon [icon]="faFileWord"
                                 class="text-blue-50 fa-lg file-badge display-inline-block text-middle"></fa-icon>
                      </div>
                      <div class="grid-col fill">
                        <div class="file-title text-bold">{{ pair.right.title }}</div>
                      </div>
                      <div class="grid-col-auto">
                        <a class="usa-link display-inline-flex flex-align-center"
                           [href]="pair.right.href" target="_blank" rel="noopener"
                           aria-label="Open {{ pair.right.title }} (opens in a new tab)">
                          <fa-icon [icon]="faArrowUpRightFromSquare"
                                   class="fa-regular fa-green" aria-label="close"></fa-icon>
                          &nbsp;Open
                        </a>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  </section>
</main>
